export default {
  state: {
    tempData: {}, // 临时数据
    downLoading: false
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/app.js